import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { createReducer, updateObject } from './utils';

import * as ActionTypes from '../app/ActionTypes';

function removeItem(array, index) {
	return [...array.slice(0, index), ...array.slice(index + 1)];
}

function arrayToObject(array, keyField) {
	return Object.assign(
		{},
		...array.map(item => ({ [item[keyField]]: item }))
	);
}

/*
	Reducer cases
*/

function getRolesSuccess(state, action) {
	return action.mappedResults;
}

// FIXME: server need to send just updated role
function saveRoleSuccess(state, action) {
	const role = state[action.result.role_id];
	return {
		...state,
		[action.result.role_id]: role
	};
}

function deleteRoleRequest(state, action) {
	const newState = {
		...state
	};
	delete newState[action.roleId];
	return newState;
}

/*
	Reducer
*/

const initialState = {};

const reducer = combineReducers({
	byIds: createReducer(
		{},
		{
			[ActionTypes.GET_ROLES_SUCCESS]: (state, action) =>
				arrayToObject(action.roles, 'role_id'),
			// FIXME: server need to send just updated role
			[ActionTypes.SAVE_ROLE_SUCCESS]: (state, action) =>
				arrayToObject(action.roles, 'role_id'),
			[ActionTypes.DELETE_ROLE_REQUEST]: deleteRoleRequest,
			CLEAR_PLAN_DATAS: (state, action) => initialState
		}
	),
	allIds: createReducer([], {
		[ActionTypes.GET_ROLES_SUCCESS]: (state, action) =>
			action.roles.map(role => role.role_id),
		[ActionTypes.SAVE_ROLE_SUCCESS]: (state, action) =>
			action.roles.map(role => role.role_id),
		[ActionTypes.DELETE_ROLE_REQUEST]: (state, action) => {
			const index = state.indexOf(action.roleId);
			return removeItem(state, index);
		},
		CHANGE_RANGE_ROLES: (state, action) => action.roles,
		CLEAR_PLAN_DATAS: (state, action) => []
	})
});

/**
*	Selectors
*/
const rolesSelector = state => state.entities.roles.byIds;
const rolesAllIdsSelector = state => state.entities.roles.allIds;

const getRolesSelector = createSelector(
	rolesSelector,
	rolesAllIdsSelector,
	(byIds, allIds) => allIds.map(id => byIds[id])
);

const getRoleSelector = createSelector(rolesSelector, rolesByIds => {
	return roleId => rolesByIds[roleId];
});

// const getRoles = createSelector(rolesSelector, rolesByIds => {
// 	return Ids => Ids.map(id => rolesByIds[id]);
// });

export default reducer;
export { getRolesSelector, getRoleSelector };



// WEBPACK FOOTER //
// ./src/js/reducers/roles.js